import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
// Import JSX Modules
import MobileSort from './mobile-sort';
import MobileDeliveryOptionFilters from './mobile-delivery-option-filters';
import MobileFilter from './mobile-filter';

// -----------------------------------------------------------
//  MobileFilters
// -----------------------------------------------------------
var MobileFilters = createReactClass({
  displayName: 'Filters',
  render: function(){
    return (
      <aside className="filters border-radius mobile-filters-side">
        <MobileSort value={ this.props.sortValue }
                    onChange={ this.props.onSortChange } />

        <MobileDeliveryOptionFilters options={ this.props.delivery_options }
                               facets={ (this.props.facets || {})['faceted_delivery_options'] }
                               selectedOptions={ this.props.selected_delivery_options || [] }
                               onOptionSelected={ this.props.onDeliveryOptionSelected }/>
        {
          this.props.filters.map(function(filter){
            var facets = (this.props.facets || {})['filter_' + filter.key];

            return <MobileFilter { ...filter }
                                 facets={ facets }
                                 key={ filter.key }
                                 name={ filter.key }
                                 title={ filter.label }
                                 options={ filter.options }
                                 selectedOptions={ this.props.selected_filters[filter.key] || [] }
                                 onOptionSelected={ this.props.onFilterOptionSelected } />;
          }, this)
        }
      </aside>
    );
  }
});

export default MobileFilters;
